module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("922rR"))).then(() => module.bundle.root('f4eak'));